'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var res = null; // eslint-disable-line import/no-mutable-exports
if (process.env.IS_WEBPACK) {
    res = require('./WHLoggerBrowser').default; // eslint-disable-line global-require
} else {
    res = require('./WHLogger').default; // eslint-disable-line global-require
}

exports.default = res;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/logger/dist/main/index.js
// module id = 471
// module chunks = 0